//= Functions & Modules
// Others
import React from 'react';

export class NoConnection extends React.PureComponent {
    render() {
        return <div>No connection</div>;
    }
}
